import { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import { useParams } from 'react-router-dom'
import { collection, addDoc, serverTimestamp, updateDoc, doc, query, onSnapshot } from 'firebase/firestore'
import { getDownloadURL, ref, uploadBytes} from 'firebase/storage'

import { database, storage }  from '../../services/firebase'

import { AuthContext } from '../../App'

import { Header } from '../../components/header'

import styles from '../../styles/pages/capacitacoes.module.scss'
import 'react-toastify/dist/ReactToastify.css'

import Inputmask from 'inputmask'

export function AdminServicoDisponivel() {
    const { user, userSettings } = useContext(AuthContext)

    const params = useParams()

    const [imagem, setImagem] = useState('')
    const [imageUrl, setImageUrl] = useState('')
    const [titulo, setTitulo] = useState('')
    const [tipo, setTipo] = useState('')
    const [descricao, setDescricao] = useState('')
    const [contato, setContato] = useState('')
    const [email, setEmail] = useState('')
    const [whatsapp, setWhatsapp] = useState('')
    const [sala, setSala] = useState('')
    const [link, setLink] = useState('')

    useEffect(() => {
        let isMounted = true

        if(isMounted) {
            if(params.id) {
                const q = query(collection(database, "servicosDisponiveis"));
                onSnapshot(q, (querySnapshot) => {
                    const items = [];
                    
                    querySnapshot.forEach((doc) => {
                        if(doc.id == params.id){
                            items.push({ id: doc.id, ...doc.data() })
                        }
                    });
    
                    
                    setTitulo(items[0].titulo)
                    setImageUrl(items[0].imageUrl)
                    setTipo(items[0].tipo)
                    setDescricao(items[0].descricao)
                    setContato(items[0].contato)
                    setEmail(items[0].email)
                    setWhatsapp(items[0].whatsapp)
                    setSala(items[0].sala)
                    setLink(items[0].link)
    
                    return items
                });
            }
        }

        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        if(imagem != '') {
            setImageUrl(URL.createObjectURL(imagem[0]))
        }
    }, [imagem])

    async function handleCreation(event) {
        event.preventDefault()

        document.querySelector('button').innerHTML = `
            <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                class="spin feather feather-loader"
            >
                <line x1="12" y1="2" x2="12" y2="6"></line>
                <line x1="12" y1="18" x2="12" y2="22"></line>
                <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
                <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
                <line x1="2" y1="12" x2="6" y2="12"></line>
                <line x1="18" y1="12" x2="22" y2="12"></line>
                <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
                <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
            </svg>
        `
        document.querySelector('button').setAttribute('disabled', 'disabled')
         
        if(imagem[0] == null) {
            toast('Imagem obrigatória', { type: 'error' })

            document.querySelector('button').innerHTML = `Cadastrar`
            document.querySelector('button').removeAttribute('disabled')

            return
        } 

        const filename = new Date().getTime()

        const imageRef = ref(storage, `images/${filename + imagem[0].name}`)
        uploadBytes(imageRef, imagem[0]).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((imageUrl) => {
                addDoc(collection(database, 'servicosDisponiveis'), {
                    imageUrl,
                    titulo,
                    tipo,
                    descricao,
                    contato,
                    email,
                    whatsapp,
                    sala,
                    link,
                    created_at: serverTimestamp()
                })
                .then(() => {
                    toast('Item criado com sucesso', { type: 'success' })

                    location.href = '/admin/servicos-disponiveis'
                })
            }) 
        })
    }

    async function handleEdit(event) {
        event.preventDefault()

        document.querySelector('button').innerHTML = `
            <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                class="spin feather feather-loader"
            >
                <line x1="12" y1="2" x2="12" y2="6"></line>
                <line x1="12" y1="18" x2="12" y2="22"></line>
                <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
                <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
                <line x1="2" y1="12" x2="6" y2="12"></line>
                <line x1="18" y1="12" x2="22" y2="12"></line>
                <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
                <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
            </svg>
        `
        document.querySelector('button').setAttribute('disabled', 'disabled')

        try {
            if(imagem == ''){
                await updateDoc(doc(database, 'servicosDisponiveis', params.id), {
                    titulo,
                    tipo,
                    descricao,
                    contato,
                    email,
                    whatsapp,
                    sala,
                    link
                })
            } else {
                const filename = new Date().getTime()
                
                const imageRef = ref(storage, `images/${filename + imagem[0].name}`)
                await uploadBytes(imageRef, imagem[0]).then((snapshot) => {
                    getDownloadURL(snapshot.ref).then(async (imageUrl) => {
                        await updateDoc(doc(database, 'servicosDisponiveis', params.id), {
                            imageUrl,
                            titulo,
                            tipo,
                            descricao,
                            contato,
                            email,
                            whatsapp,
                            sala,
                            link
                        })
                    }) 
                })
            }  
            
            toast('Item editado com sucesso', { type: 'success' })

            document.querySelector('button').innerHTML = `Editar`
            document.querySelector('button').removeAttribute('disabled')
        } catch(error) {
            toast('Tivemos um problema ao editar este item', { type: 'error' })
            console.log(error)

            document.querySelector('button').innerHTML = `Editar`
            document.querySelector('button').removeAttribute('disabled')
        }
    }

    useEffect(() =>{
        Inputmask({"mask": "(99) 99999-9999"}).mask('#whatsapp')
        Inputmask({"mask": "(99) 9999-9999"}).mask('#phone')
    }, [])

    return (
        <>
            { params.id ? (
                <div className={`${ styles.content } ${ styles.contentAdmin } ${ userSettings?.type }`}>
                    <Header />

                    <div className={styles.dashboardHolder}>
                        <div className={styles.servicosDisponiveisDescription}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                                <span>/editar serviço</span>

                                <Link 
                                    to="/admin/servicos-disponiveis" 
                                    style={{ 
                                        background: '#fff', 
                                        textDecoration: 'none',  
                                        display: 'inline-block' , 
                                        color: '#000',
                                        padding: '5px 10px',
                                        borderRadius: 20
                                    }}>
                                        voltar
                                </Link>
                            </div>

                            <div className={styles.capacitacoesHolder}>
                                <form onSubmit={handleEdit} encType="multipart/form-data">
                                    <div>
                                        <label htmlFor="imagem">
                                            { imageUrl == '' ? (
                                                <div className={styles.thumbnail}>+</div>
                                            ) : (
                                                <div className={styles.thumbnail}>
                                                    <img 
                                                        src={imageUrl} 
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                                                        alt="" 
                                                    />
                                                </div>
                                            ) }

                                            <input type="file" style={{ display: 'none' }} name="imagem" id="imagem" onChange={event => setImagem(event.target.files)} />
                                        </label>
                                    </div>

                                    <div>
                                        <label htmlFor="titulo">Título</label>
                                        <input type="text" value={titulo} onChange={event => setTitulo(event.target.value)} required/>
                                    </div>

                                    <div>
                                        <label htmlFor="tipo">Tipo</label>
                                        <input type="text" value={tipo} onChange={event => setTipo(event.target.value)} />
                                    </div>

                                    <div>
                                        <label htmlFor="descricao">Descrição</label>
                                        <textarea value={descricao} onChange={event => setDescricao(event.target.value)} />
                                    </div>

                                    <div>
                                        <label htmlFor="contato">Contato</label>
                                        <input type="text" id="phone" value={contato} onChange={event => setContato(event.target.value)} />
                                    </div>

                                    <div>
                                        <label htmlFor="email">Email</label>
                                        <input type="email" value={email} onChange={event => setEmail(event.target.value)} />
                                    </div>

                                    <div>
                                        <label htmlFor="whatsapp">Whatsapp</label>
                                        <input type="text" id="whatsapp" value={whatsapp} onChange={event => setWhatsapp(event.target.value)} />
                                    </div>

                                    <div>
                                        <label htmlFor="sala">Sala</label>
                                        <input type="text" value={sala} onChange={event => setSala(event.target.value)} required/>
                                    </div>

                                    <div>
                                        <label htmlFor="link">Link</label>
                                        <input type="text" value={link} onChange={event => setLink(event.target.value)} />
                                    </div>

                                    <div>
                                        <button type="submit">Editar</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={`${ styles.content } ${ styles.contentAdmin } ${ userSettings?.type }`}>
                    <Header />

                    <div className={styles.dashboardHolder}>
                        <div className={styles.servicosDisponiveisDescription}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                                <span>/cadastrar novo serviço</span>

                                <Link 
                                    to="/admin/servicos-disponiveis" 
                                    style={{ 
                                        background: '#fff', 
                                        textDecoration: 'none',  
                                        display: 'inline-block' , 
                                        color: '#000',
                                        padding: '5px 10px',
                                        borderRadius: 20
                                    }}>
                                        voltar
                                </Link>
                            </div>

                            <div className={styles.capacitacoesHolder}>
                                <form onSubmit={handleCreation} encType="multipart/form-data">
                                    <div>
                                        <label htmlFor="imagem">
                                            { imageUrl == '' ? (
                                                <div className={styles.thumbnail}>+</div>
                                            ) : (
                                                <div className={styles.thumbnail}>
                                                    <img 
                                                        src={imageUrl} 
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                                                        alt="" 
                                                    />
                                                </div>
                                            ) }

                                            <input type="file" style={{ display: 'none' }} name="imagem" id="imagem" onChange={event => setImagem(event.target.files)} />
                                        </label>
                                    </div>

                                    <div>
                                        <label htmlFor="titulo">Título</label>
                                        <input type="text" value={titulo} onChange={event => setTitulo(event.target.value)} required/>
                                    </div>

                                    <div>
                                        <label htmlFor="tipo">Tipo</label>
                                        <input type="text" value={tipo} onChange={event => setTipo(event.target.value)} />
                                    </div>

                                    <div>
                                        <label htmlFor="descricao">Descrição</label>
                                        <textarea value={descricao} onChange={event => setDescricao(event.target.value)} />
                                    </div>

                                    <div>
                                        <label htmlFor="contato">Contato</label>
                                        <input type="text" id="phone" value={contato} onChange={event => setContato(event.target.value)} />
                                    </div>

                                    <div>
                                        <label htmlFor="email">Email</label>
                                        <input type="email" value={email} onChange={event => setEmail(event.target.value)} />
                                    </div>

                                    <div>
                                        <label htmlFor="whatsapp">Whatsapp</label>
                                        <input type="text" id="whatsapp" value={whatsapp} onChange={event => setWhatsapp(event.target.value)} />
                                    </div>

                                    <div>
                                        <label htmlFor="sala">Sala</label>
                                        <input type="text" value={sala} onChange={event => setSala(event.target.value)} required/>
                                    </div>

                                    <div>
                                        <label htmlFor="link">Link</label>
                                        <input type="text" value={link} onChange={event => setLink(event.target.value)} />
                                    </div>

                                    <div>
                                        <button type="submit">Cadastrar</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            ) }
            
        </>
    )
}